import { formatPrice } from '@lib/formatting.utils'
import { getProp } from '@lib/generic.utils'

export const notAnyValueCheck = params => params.value || 'N/A'
export const notAnyPriceCheck = (params, currencyField = 'currency', isTooltip) => {
  const price = formatPrice(params.value)
  const currency = getProp(params.data, currencyField)

  if (!price) return 'N/A'

  if (isTooltip) return `${price} ${currency}`
  return `${price} <small>${currency}</small>`
}
